
import useBookingState                  from '../Booking/bookingReducer'
/* 
 * React component to display an overlay over the calendar to allow the user
 * change the time that they selected in the calendar. This component also 
 * presents error messages if the time selected, is not available for the selected 
 * appoinment type. 
 */

import React, {useState, useEffect}     from 'react'

import {TwoTimeEdit}                    from '../../lib/iprs-react-library/src/index.js'
import {OKCancel}                       from '../../lib/iprs-react-library/src/index.js';
import {personCalendarClick}            from '../Booking/bookingReducer';

const BookingProcessOverlay = ({api, selectInfo, done, calendarApi, setError, state, eventDispatch}) => {
    
    const [bookingState, bookingUpdater] = useBookingState(state, eventDispatch);
    
    const {start, end, resource: { id: partyID = 0 } = {} } = selectInfo
    
    /* state of form elements */
    const [startTime, setStartTime]                 = useState(start);
    const [endTime,   setEndTime]                   = useState(end);
    
    const [enabled, setEnabled]                     = useState(false);
    
    const appTypeID = bookingState.newBooking.getAppoinmnetTypeID();
    
    useEffect( () => {
        
    
        /* We are in the booking process and have clicked into someone's diary.
         * Load the list of available appointment types*/
        api.transact('GetPartyTimeAppointmentTypeList', {
            PartyID: partyID,
            StartTime: startTime,
            FinishTime: endTime,
            VisualCall: bookingState.newBooking.isVisual
        })
            .then( r => r.apiResult )
            .then( r    => {
                if( appTypeID ){
                    const count = r.filter( t => t === appTypeID ).length;
            
                    if( !count ){
                        
                        // a bit ugly but app type on the booking only has the 
                        // ID and a null title so get this from the app type 
                        // list on the state
                        const appTypeTitle = state?.appType?.appointmentTypes?.find?.( a => a.AppointmentTypeID === appTypeID )?.Title?? '';
                        
                        setError( 'This person is not available for \'' + appTypeTitle + '\' at that time' );
                        setEnabled(false);
                    }else{
                        setEnabled(true);
                        setError(null);
                    }
                }else{
                    const count = r.length;
            
                    if( !count ){
                        setError( 'This person is not available at that time' );
                        setEnabled(false);
                    }else{
                        setEnabled(true);
                        setError(null);
                    }
                }
            })
            .catch( err => setError(err.message) ); 
    }, [api, partyID, startTime, endTime, appTypeID, bookingState.newBooking.isVisual, setError, state?.appType?.appointmentTypes]);
    
    
    const handleMakeBooking = e => {
        e.preventDefault();
        
        personCalendarClick( api, bookingState, bookingUpdater, partyID, startTime, endTime );
    }
    
    return (<>
    
        <h2>Edit the Times</h2>
        <p>Change if the times are not exactly correct.</p>
        
        <TwoTimeEdit start={startTime} end={endTime} onStartChange={setStartTime} 
            onEndChange={setEndTime} startLabel='Start Time' endLabel='End Time' />
        
        <p></p>
        <OKCancel onOK={handleMakeBooking} onCancel={done} okText={'Continue Booking'} enabled={enabled} />
    </>)
}

export default BookingProcessOverlay 

